import React from 'react';
import './SpellCheckSuggestions.css';

const SpellCheckSuggestions = ({
    errorData,
    onSelectSuggestion,
    onIgnore,
    position
}) => {
    if (!errorData || !errorData.s || errorData.s.length === 0) return null;

    const isRussian = /[а-яё]/i.test(errorData.word);
    const langClass = isRussian ? 'ru' : 'en';

    return (
        <div
            className={`spelling-suggestions ${langClass}`}
            style={{
                position: 'fixed',
                left: `${position.left}px`,
                top: `${position.top}px`,
                zIndex: 9999
            }}
        >
            <div className="suggestion-title">
                {isRussian ? 'Варианты исправления:' : 'Correction suggestions:'}
            </div>

            <div className="suggestion-item original">
                <strong>{isRussian ? 'Оригинал:' : 'Original:'}</strong> {errorData.word}
            </div>

            <div className="suggestion-divider" />

            {errorData.s.map((suggestion, index) => (
                <div
                    key={index}
                    className={`suggestion-item ${index === 0 ? 'primary' : ''}`}
                    onClick={() => onSelectSuggestion(suggestion)}
                >
                    {index === 0 && <i className="fas fa-check-circle suggestion-icon" />}
                    {suggestion}
                </div>
            ))}

            <div className="suggestion-item ignore" onClick={onIgnore}>
                <i className="fas fa-times-circle" />
                {isRussian ? 'Игнорировать' : 'Ignore'}
            </div>

            <div className="suggestion-arrow" />
        </div>
    );
};

export default SpellCheckSuggestions;